module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution1_2@2x-2b8e0e7f1de3a73a3aae4195b8389f30.png";